import { Entity, Fields, Relations, Allow } from "remult";
import { User } from "../user/entity";

@Entity("user-statistics", {
    allowApiRead: false, // @@deny('all', true) in .zmodel
    allowApiCrud: false
})
export class UserStatistics {
    @Fields.string()
    id = "";

    @Fields.string({ dbName: "user_id" })
    userId = "";

    @Relations.toOne(() => User, "userId")
    user?: User;

    @Fields.number({ dbName: "distance_weight" })
    distanceWeight = 1;

    @Fields.number({ dbName: "urgency_weight" })
    urgencyWeight = 1;

    @Fields.number({ dbName: "manager_urgency_weight" })
    managerUrgencyWeight = 1;

    @Fields.number({ dbName: "population_match_weight" })
    populationMatchWeight = 1;

    @Fields.number({ dbName: "category_match_weight" })
    categoryMatchWeight = 1;

    @Fields.number({ dbName: "remote_mean" })
    remoteMean = 0.5;

    @Fields.number({ dbName: "remote_weight" })
    remoteWeight = 1;

    @Fields.createdAt({ dbName: "created_at" })
    createdAt = new Date();

    @Fields.updatedAt({ dbName: "updated_at" })
    updatedAt = new Date();
}
